import { prewarmAgentSession } from "@/lib/agent-prewarm";
import { useInputBarTarget } from "@/stores/input-bar-target-store";

const NEW_CHAT_COMMAND = /^[@/]new(?:\s+|$)/i;

/** A draft led by `@new` or `/new` starts a new chat; returns the request
 *  that follows (its first message, possibly empty), or null for any other
 *  draft. The one grammar every composer reads. */
export function parseNewChatCommand(draft: string): string | null {
  const text = draft.trim();
  const command = NEW_CHAT_COMMAND.exec(text);
  return command ? text.slice(command[0].length) : null;
}

/** The standalone surfaces' New chat: the shared route sends the next typed
 *  or spoken message to a new chat, whose session starts warming now. */
export function requestStandaloneNewChat(): void {
  useInputBarTarget.getState().requestNewConversation();
  prewarmAgentSession("new_chat", { force: true, startNewConversation: true });
}
